import React, { useState } from 'react';
import { Mail, Phone, MapPin, SendIcon, CheckCircleIcon } from 'lucide-react';
export const Contact: React.FC = () => {
  const [formState, setFormState] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormState(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    // Simulate form submission
    setTimeout(() => {
      setIsLoading(false);
      setIsSubmitted(true);
      setFormState({
        name: '',
        email: '',
        subject: '',
        message: ''
      });
    }, 1500);
  };
  return <div className="min-h-screen bg-white dark:bg-gray-900 w-full" data-id="element-1198">
      {/* Hero Section */}
      <section className="relative bg-gray-100 dark:bg-gray-800 py-16 md:py-24" data-id="element-1199">
        <div className="container mx-auto px-4" data-id="element-1200">
          <div className="max-w-3xl mx-auto text-center" data-id="element-1201">
            <h1 className="text-4xl md:text-5xl font-bold mb-6 text-gray-900 dark:text-white" data-id="element-1202">
              Võta <span className="text-yellow-500" data-id="element-1203">Ühendust</span>
            </h1>
            <p className="text-lg text-gray-700 dark:text-gray-300" data-id="element-1204">
              Küsimused või tagasiside? Võtke meiega ühendust.
            </p>
          </div>
        </div>
        <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-white dark:from-gray-900 to-transparent" data-id="element-1205"></div>
      </section>
      {/* Contact Information */}
      <section className="py-12" data-id="element-1206">
        <div className="container mx-auto px-4" data-id="element-1207">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-1208">
            <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300 transform hover:-translate-y-1" data-id="element-1209">
              <div className="flex flex-col items-center text-center" data-id="element-1210">
                <div className="w-14 h-14 bg-yellow-100 dark:bg-yellow-900/30 rounded-full flex items-center justify-center mb-4" data-id="element-1211">
                  <Mail size={24} className="text-yellow-500" data-id="element-1212" />
                </div>
                <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2" data-id="element-1213">
                  Kirjuta Meile
                </h3>
                <p className="text-gray-600 dark:text-gray-400 mb-4" data-id="element-1214">
                  Meie meeskond on siin, et aidata
                </p>
                <a href="mailto:info@annelinnapandimaja.com" className="text-yellow-500 hover:text-yellow-600 font-medium transition-colors" data-id="element-1215">
                  info@annelinnapandimaja.com
                </a>
              </div>
            </div>
            <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300 transform hover:-translate-y-1" data-id="element-1216">
              <div className="flex flex-col items-center text-center" data-id="element-1217">
                <div className="w-14 h-14 bg-yellow-100 dark:bg-yellow-900/30 rounded-full flex items-center justify-center mb-4" data-id="element-1218">
                  <Phone size={24} className="text-yellow-500" data-id="element-1219" />
                </div>
                <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2" data-id="element-1220">
                  Helista Meile
                </h3>
                <p className="text-gray-600 dark:text-gray-400 mb-4" data-id="element-1221">
                  E-R kella 9-18
                </p>
                <a href="tel:+37251234567" className="text-yellow-500 hover:text-yellow-600 font-medium transition-colors" data-id="element-1222">
                  +372 5123 4567
                </a>
              </div>
            </div>
            <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300 transform hover:-translate-y-1" data-id="element-1223">
              <div className="flex flex-col items-center text-center" data-id="element-1224">
                <div className="w-14 h-14 bg-yellow-100 dark:bg-yellow-900/30 rounded-full flex items-center justify-center mb-4" data-id="element-1225">
                  <MapPin size={24} className="text-yellow-500" data-id="element-1226" />
                </div>
                <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2" data-id="element-1227">
                  Külasta Meid
                </h3>
                <p className="text-gray-600 dark:text-gray-400 mb-4" data-id="element-1228">
                  Tule külla meie kontorisse
                </p>
                <span className="text-yellow-500" data-id="element-1229">Annelinn, Tartu, Eesti</span>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Contact Form */}
      <section className="py-12 bg-gray-50 dark:bg-gray-800" data-id="element-1230">
        <div className="container mx-auto px-4" data-id="element-1231">
          <div className="max-w-3xl mx-auto" data-id="element-1232">
            <div className="bg-white dark:bg-gray-900 rounded-lg shadow-md overflow-hidden" data-id="element-1233">
              <div className="p-6 md:p-8" data-id="element-1234">
                <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-6" data-id="element-1235">
                  Saada Meile Sõnum
                </h2>
                {isSubmitted ? <div className="bg-green-50 dark:bg-green-900/20 p-6 rounded-lg text-center" data-id="element-1236">
                    <div className="inline-flex items-center justify-center w-12 h-12 bg-green-100 dark:bg-green-900/30 rounded-full mb-4" data-id="element-1237">
                      <CheckCircleIcon size={24} className="text-green-600 dark:text-green-400" data-id="element-1238" />
                    </div>
                    <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2" data-id="element-1239">
                      Täname!
                    </h3>
                    <p className="text-gray-600 dark:text-gray-400" data-id="element-1240">
                      Teie sõnum on edukalt saadetud. Vastame teile esimesel
                      võimalusel.
                    </p>
                    <button onClick={() => setIsSubmitted(false)} className="mt-4 inline-flex items-center px-4 py-2 bg-yellow-500 hover:bg-yellow-600 text-white rounded-md font-medium transition-colors" data-id="element-1241">
                      Saada Uus Sõnum
                    </button>
                  </div> : <form onSubmit={handleSubmit} className="space-y-6" data-id="element-1242">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1243">
                      <div data-id="element-1244">
                        <label htmlFor="name" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-1245">
                          Teie Nimi
                        </label>
                        <input type="text" id="name" name="name" value={formState.name} onChange={handleChange} required className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-2 focus:ring-yellow-500 transition-colors" placeholder="Jaan Tamm" data-id="element-1246" />
                      </div>
                      <div data-id="element-1247">
                        <label htmlFor="email" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-1248">
                          Teie E-post
                        </label>
                        <input type="email" id="email" name="email" value={formState.email} onChange={handleChange} required className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-2 focus:ring-yellow-500 transition-colors" placeholder="jaan@näide.ee" data-id="element-1249" />
                      </div>
                    </div>
                    <div data-id="element-1250">
                      <label htmlFor="subject" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-1251">
                        Teema
                      </label>
                      <select id="subject" name="subject" value={formState.subject} onChange={handleChange} required className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-2 focus:ring-yellow-500 transition-colors" data-id="element-1252">
                        <option value="" data-id="element-1253">Vali teema</option>
                        <option value="general" data-id="element-1254">Üldine Päring</option>
                        <option value="support" data-id="element-1255">Toote Tugi</option>
                        <option value="returns" data-id="element-1256">
                          Tagastused ja Tagasimaksed
                        </option>
                        <option value="partnership" data-id="element-1257">Ärikoostöö</option>
                      </select>
                    </div>
                    <div data-id="element-1258">
                      <label htmlFor="message" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-1259">
                        Sõnum
                      </label>
                      <textarea id="message" name="message" value={formState.message} onChange={handleChange} required rows={5} className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-2 focus:ring-yellow-500 transition-colors" placeholder="Kuidas saame teid aidata?" data-id="element-1260"></textarea>
                    </div>
                    <div data-id="element-1261">
                      <button type="submit" disabled={isLoading} className={`w-full flex items-center justify-center px-6 py-3 bg-yellow-500 hover:bg-yellow-600 text-white rounded-md font-medium transition-all duration-300 transform hover:scale-105 ${isLoading ? 'opacity-70 cursor-not-allowed' : ''}`} data-id="element-1262">
                        {isLoading ? <>
                            <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" data-id="element-1263">
                              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" data-id="element-1264"></circle>
                              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" data-id="element-1265"></path>
                            </svg>
                            Saadan...
                          </> : <>
                            <SendIcon size={18} className="mr-2" data-id="element-1266" />
                            Saada Sõnum
                          </>}
                      </button>
                    </div>
                  </form>}
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Map Section */}
      <section className="py-12" data-id="element-1267">
        <div className="container mx-auto px-4" data-id="element-1268">
          <div className="bg-gray-200 dark:bg-gray-800 h-80 rounded-lg overflow-hidden" data-id="element-1269">
            <div className="w-full h-full flex items-center justify-center bg-gray-300 dark:bg-gray-700" data-id="element-1270">
              <p className="text-gray-600 dark:text-gray-400" data-id="element-1271">
                Kaardi kohatäide - Interaktiivne kaart kuvatakse siin
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>;
};